import FilterNewTag
    from "app/pages/sales-intelligence/common-components/filters-panel/components/FilterNewTag/FilterNewTag";

import IndustryCodesFilter from "../../components/filters/IndustryCodesFilter/IndustryCodesFilter";
import IndustryCodesFilterResult from "../../components/filters/IndustryCodesFilter/IndustryCodesFilterResult";
import { leadsFilterApiCategory } from "../../types/leadsFilterApiCategory";
import { leadsFilterCategoryMap } from "../../types/leadsFilterCategory";
import leadsSearchFiltersI18nKeys from "../../utils/i18n";
import { defineDescriptionFilter } from "../defineSourcedFilter";

import IndustryCodesFilterModel from "./IndustryCodesFilterModel";

/**
 * SIC/NAICS codes, split out of the legacy industry filter by SI-8806. Sourced on the description — unlike
 * its legacy sibling, which builds eagerly and falls back to empties — because the whole card is code
 * dropdowns, so rendering it before the option lists resolve would offer nothing to pick.
 */
export const industryCodesFilterDefinition = defineDescriptionFilter({
    key: "industryCodesFilter",
    apiCategory: leadsFilterApiCategory.industryCodesFilter,
    category: leadsFilterCategoryMap.company,
    trackingName: "industry codes",
    titleKey: { key: leadsSearchFiltersI18nKeys.filter("industryCodesFilter") },

    render: ({ description }) => ({
        tag: FilterNewTag,
        tooltipText: { key: leadsSearchFiltersI18nKeys.filterTooltip("industryCodesFilter") },
        filter: new IndustryCodesFilterModel({
            options: {
                inclusionOptions: description.industry.inclusionOptions,
                naicsCode: description.naicsCode,
                sicCodes: description.sicCodes,
            },
        }),
        filterView: IndustryCodesFilter,
        filterResultView: IndustryCodesFilterResult,
    }),
});
